export const meta = {
  title: 'Billing & your subscription',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'staff'],
};

Everything about what you pay lives on the **Billing** page of your dashboard: your plan, your trial state, your next billing date, how many outlets you're being charged for, and every invoice ever issued. No mystery charges — every change is written to an audit log you can read.

## The trial

Your account starts with a **14-day free trial** with full access — no card on file, nothing charged. The Billing page shows exactly how many trial days remain. Cancel during the trial and you owe nothing.

## How the monthly invoice works

Billing runs **in arrears**: shortly after midnight on the 1st of each month, one invoice is issued covering the month that just ended. It itemises your plan, any extra outlets, and any prorated changes you made mid-month, so the total is never a surprise.

## Paying an invoice

Each open invoice on the Billing page carries a **Pay now** button. It opens a secure FPX payment page — pay directly from any Malaysian bank account. Once the bank confirms, the invoice flips to _paid_ automatically, usually within moments.

If a payment link has gone stale, use the refresh action next to the invoice to issue a fresh link. Note that only the **newest** link for an invoice can settle it — old links are refused rather than risking a double charge.

## Adding an outlet

Add outlets from the **Outlets** page. Before you confirm, you see a live preview of the prorated charge — you only pay for the days remaining in the current month, and that amount lands on your next invoice. The new outlet is usable immediately, with its own queue and QR code.

## Removing an outlet

Removing an outlet takes effect at the **end of the month**. It keeps working until then — you've already paid for those days — and simply drops off from your next invoice. The Billing page lists the pending removal with its effective date so there's no guesswork.

## SST and tax invoices

If your business is SST-registered, open the tax card on the Billing page (owner only), switch it on, and enter your SST number and legal entity details. Every invoice from then on carries an SST line and its PDF renders as a proper tax invoice.

## Invoice PDFs

Every invoice has a **PDF** button — download it for your bookkeeper or your records. Paid invoices show when and how they were settled.

## The audit trail

The Billing page ends with your **subscription events** ledger: every plan change, outlet addition, removal, and charge, timestamped. If a number on an invoice ever looks unfamiliar, the ledger tells you exactly where it came from.
